/**
 * Toggle Search Action
 * Triggered by: arc:action:toggleSearch
 *
 * Adds or removes the 'opensearch-active' class on <body> when toggled on/off.
 * Usage: window.dispatchEvent(new CustomEvent('arc:action:searchToggle', { detail: { open: true } }))
 */

export const runSearchToggle = async (data = {}) => {
  try {
    const { open } = data;

    window.dispatchEvent(
      new CustomEvent('toggle-search', {
        detail: {}
      })
    );
    return {
      success: true,
      open
    };
  } catch (error) {
    console.error('runSearchToggle error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

export default runSearchToggle;
